import { combineReducers } from 'redux';
import getApiReducer from '../utils/getApiReducer';
import store from 'store2';

import { GET_ROLES } from './actions';
const token = (state = store.get('idToken'), action) => {
  return state;
};

const roles = getApiReducer(GET_ROLES);

export default combineReducers({
  token,
  roles,
});



// WEBPACK FOOTER //
// ./src/common/auth/reducers.js